// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__31xNP","options":"AnswerScale_options__1w8N2","selected":"AnswerScale_selected__YDbvv"};